var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8651993B-BA5B-4E72-80F4-970A6AD4AB04") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---12---Filters",
    transform: "translate(-567.000000, -1463.000000)",
    fill: "#202020",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(65.000000, 250.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(502.000000, 1210.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C8.81736559,3 5.76518739,4.26427668 3.51477489,6.51477489 C1.26427668,8.76510168 0,11.8174513 0,15 C0,18.1825487 1.26427668,21.2348126 3.51477489,23.4852251 C5.76510168,25.7357233 8.8174513,27 12,27 C14.1063278,27 16.175713,26.4455182 17.9999571,25.3923543 C19.8242013,24.339019 21.3389333,22.824287 22.3923543,20.9999571 C23.4455182,19.175713 24,17.1063278 24,15 C24,11.8173656 22.7357233,8.76518739 20.4852251,6.51477489 C18.2348983,4.26427668 15.1825487,3 12,3 Z M15.0696209,15.2399126 L9.40780423,20.8991579 C9.34485611,20.9637774 9.25813958,21.0002743 9.16790451,20.9999423 C9.07766945,20.999103 8.99145435,20.9629426 8.92783766,20.8991579 C8.79608717,20.7662331 8.79608717,20.5519489 8.92783766,20.4192041 L14.3492275,14.9999571 L8.9299805,9.58071014 C8.79823001,9.44795251 8.79823001,9.23366833 8.9299805,9.10075642 C8.99326291,9.03630403 9.07964515,8.99997429 9.17004736,8.99997429 C9.26028243,8.99997429 9.34683181,9.03630231 9.40994707,9.10075642 L15.0717638,14.7600017 C15.2028457,14.893595 15.2018428,15.1078792 15.06942,15.2401269 L15.0696209,15.2399126 Z",
    id: "Shape-Copy",
    transform: "translate(12.000000, 15.000000) scale(-1, 1) translate(-12.000000, -15.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevInactive);
export default __webpack_public_path__ + "static/media/prev-inactive.52a4fcae9e57e15b93c6e5dbe86d0d1c.svg";
export { ForwardRef as ReactComponent };